// Single source of truth for live portal route paths and external-system
// path segments. Shop / category-tree paths live in app/utils/categoryRoutes.ts.
// See docs/migration-rules.md §5.

// ─── Portal ──────────────────────────────────────────────────────────────
export const PORTAL_ROOT = '/portal' as const

// Current Updates.
export const PORTAL_CURRENT_UPDATES = '/portal/current-updates' as const

// Legacy business resources prefix. Nuxt 2 rewrites update URLs under this
// prefix back to /portal for the visible homepage updates list.
export const PORTAL_BUSINESS_RESOURCES = '/portal/business-resources' as const

// Marketing Toolkit. Doubles as the slug the S3 category tree publishes the
// toolkit sections under, so the store looks the category up by this exact
// value (see app/stores/marketing-toolkit.ts).
export const PORTAL_MARKETING_TOOLKIT = '/portal/marketing-toolkit' as const

// DBWS subscribe / upsell landing page. Also reachable via the legacy
// /portal/business-resources/my-dbws alias (see app/router.options.ts).
export const PORTAL_DBWS_SUBSCRIBE = '/portal/dbws/subscribe-now' as const

// Marker slug for the "Sign into your personal website" nav item — not a real
// page. The header nav intercepts a click on this slug and performs a seamless
// DBWS login (see MenuItemList.vue). It must be distinct from
// PORTAL_DBWS_SUBSCRIBE so "Subscribe Now" can navigate normally while only
// this item logs in. AB#60136
export const PORTAL_DBWS_LOGIN = '/portal/dbws/login' as const

// Stampin' University — Leaders Lounge.
export const PORTAL_LEADERS_LOUNGE = '/portal/stampin-university/leaders-lounge' as const

// Leaders Lounge no-access redirect target (shown when a demonstrator is below
// Silver Elite and is not an agent).
export const PORTAL_NO_ACCESS_LEADERS_LOUNGE = '/portal/stampin-university/no-access-leaders-lounge' as const

// View My Reports. Also matched as a substring when classifying CMS link
// hrefs (see CmsContent.vue); the value is already lowercase.
export const PORTAL_REPORTS = '/portal/reports' as const

// ─── Breadcrumbs ─────────────────────────────────────────────────────────
// The S3 category tree does not include the demonstrator portal, so portal
// breadcrumbs fall back to a kebab→Title-Case derivation of the URL segment.
// That loses curated labels (e.g. the apostrophe in "Stampin' University"),
// so map the portal segments that need a specific label here. Nuxt 2 rendered
// these exact labels. Keyed by the URL path segment (not the full path).
export const PORTAL_BREADCRUMB_LABELS: Record<string, string> = {
  'stampin-university': 'Stampin\' University'
}

// ─── External-system path segment ────────────────────────────────────────
// Matched as a case-insensitive substring when classifying CMS link hrefs
// (CmsContent.vue lowercases the href first), so kept lowercase.
export const PORTAL_DBWS_SEGMENT = '/portal/dbws' as const

// Legacy DBWS sign-up path used by DbwsPromo.vue (account links page). The
// route itself is still served by the legacy system via hybrid routing.
export const PORTAL_LEGACY_DBWS = '/portal/business-resources/my-dbws' as const
